
import Vue from "vue";
import { ExactService, IExactStatus } from "@/services/exact-service";
import { ClearfactsService, IClearfactsStatus, CLEARFACTS_DOMAIN_STORAGE_KEY } from "@/services/clearfacts-service";
import { AccountantService, IAccountantDossier, IExactDossierConfig } from "@/services/accountant-service";

export default Vue.extend({
	data() {
		return {
			exactStatus: {Connected: false} as IExactStatus,
			exactBusy: false,
			clearfactsStatus: {Connected: false} as IClearfactsStatus,
			clearfactsBusy: false,
			clearfactsDomain: "",
			dossiers: [] as IAccountantDossier[]
		};
	},
	methods: {
		async loadExactStatus() {
			try {
				this.exactStatus = await ExactService.getStatus();
			} catch (err) {
				this.exactStatus = {Connected: false};
			}
		},
		async loadClearfactsStatus() {
			try {
				this.clearfactsStatus = await ClearfactsService.getStatus();
			} catch (err) {
				this.clearfactsStatus = {Connected: false};
			}
		},
		async loadDossiers() {
			this.dossiers = await AccountantService.getDossiers();
			let q = this.$route.query.dossier;
			let id = parseInt(Array.isArray(q) ? q[0] || "" : q || "", 10) || 0;
			if (id) {
				this.$router.replace(`/portal/settings/${id}`);
			}
		},
		openDossier(d:IAccountantDossier) {
			this.$router.push(`/portal/settings/${d.DossierID}`);
		},
		integrationLabel(d:IAccountantDossier):string {
			if (d.IntegrationType == "exact") {
				let cfg = this.parseConfig<IExactDossierConfig>(d.Config);
				return cfg?.division_name ? this.$ct("dossiers.badge.exact-with-division", {name: cfg.division_name}).toString() : this.$ct("dossiers.badge.exact").toString();
			}
			if (d.IntegrationType == "clearfacts") return this.$ct("dossiers.badge.clearfacts").toString();
			if (d.IntegrationType == "winbooks") return this.$ct("dossiers.badge.winbooks").toString();
			if (d.IntegrationType == "yuki") return this.$ct("dossiers.badge.yuki").toString();
			return this.$ct("dossiers.badge.manual").toString();
		},
		parseConfig<T>(raw:string):T | null {
			if (!raw) return null;
			try {
				return JSON.parse(raw) as T;
			} catch {
				return null;
			}
		},
		async connectExact() {
			this.exactBusy = true;
			try {
				let res = await ExactService.getAuthorizeUrl();
				window.location.href = res.URL;
			} catch (err) {
				this.exactBusy = false;
				this.$wf.notify(this.$ct("exact.connect-failed").toString(), "error", 4000, "exclamation-triangle");
			}
		},
		async disconnectExact() {
			let ok = await this.$wf.confirm(
				this.$ct("exact.disconnect-confirm").toString(),
				this.$ct("exact.disconnect-yes").toString(),
				this.$ct("common-cancel").toString(),
				this.$ct("common-confirm").toString(),
				"warning"
			);
			if (!ok) return;
			this.exactBusy = true;
			try {
				await ExactService.disconnect();
				await this.loadExactStatus();
			} finally {
				this.exactBusy = false;
			}
		},
		async connectClearfacts() {
			this.clearfactsBusy = true;
			try {
				let domain = this.clearfactsDomain.trim();
				// Bewaren zodat de token-uitwisseling na de redirect naar dezelfde
				// host gaat als de autorisatie.
				try {
					if (domain) sessionStorage.setItem(CLEARFACTS_DOMAIN_STORAGE_KEY, domain);
					else sessionStorage.removeItem(CLEARFACTS_DOMAIN_STORAGE_KEY);
				} catch {
					// sessionStorage kan geblokkeerd zijn; de standaardhost werkt dan nog.
				}
				let res = await ClearfactsService.getAuthorizeUrl(domain);
				window.location.href = res.URL;
			} catch (err) {
				this.clearfactsBusy = false;
				this.$wf.notify(this.$ct("clearfacts.connect-failed").toString(), "error", 4000, "exclamation-triangle");
			}
		},
		async disconnectClearfacts() {
			let ok = await this.$wf.confirm(
				this.$ct("clearfacts.disconnect-confirm").toString(),
				this.$ct("clearfacts.disconnect-yes").toString(),
				this.$ct("common-cancel").toString(),
				this.$ct("common-confirm").toString(),
				"warning"
			);
			if (!ok) return;
			this.clearfactsBusy = true;
			try {
				await ClearfactsService.disconnect();
				await this.loadClearfactsStatus();
			} finally {
				this.clearfactsBusy = false;
			}
		},
		formatExpiry(s:string):string {
			let d = new Date(s);
			return d.toLocaleString("nl-BE");
		}
	},
	async mounted() {
		await Promise.all([this.loadExactStatus(), this.loadClearfactsStatus(), this.loadDossiers()]);
	},
	i18nEx: {
		componentPrefix: "views.AccountantSettings"
	}
});
